//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.MultipleObjectsBuilder.js";
import "../no/ugmath.js";
import "../no/Diagramming.js";
let d=[[],[[["owningSheet"],"SetOwningSheet",{},1,0],[["contextConnectionPort","p2dBendPoints"],"SetContextConnectionPortAndBendPoints",{},2,1],[["contextConnectionPort","p2dBendPoints"],"SetContextConnectionData",{},2,0],[["targetConnection"],"SetTargetConnection",{},1,0],[["locationX","locationY"],"SetLocation",{},2,0],[["segmentID"],"SetTargetSegmentId",{},1,0],[["junctionType"],"SetTeeJunctionType",{},1,0],[["variantIndex"],"SetTeeJunctionVariant",{},1,0],[[],"CreateTeeJunctionDiagramNode",{R_:{nodeObject:"Diagramming.Node"}},0,0]],[]];
SPLM.AME.TeeJunctionBuilder = class extends SPLM.AME.MultipleObjectsBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.TeeJunctionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;